import React from 'react';

export const ChargedOff: React.FC = () => (
  <span>This loan has been charged off.</span>
);
